import { createSlice } from '@reduxjs/toolkit';
import { isInteger, isAlphaNumeric, removeSpace } from '../regexFuncs';

export const newEventSlice = createSlice({
  name: 'newEvent',
  initialState: {
    eventName: '',
    eventDescription: '',
    eventCapacity: '',
    participantPerBox: '',
    totalBoxes: '',
    boxPrice: '',
    seatPrice: '',
    location: '',
  },

  reducers: {
    updateNewEventForm: (state, action) => {
      const { name, value } = action.payload;
      switch (name) {
        case 'eventName':
          if (value === '' || (removeSpace(value) && value.length <= 32)) {
            return { ...state, [name]: value };
          }

          return { ...state };

        case 'eventCapacity':
        case 'participantPerBox':
          const x = value === '' ? true : isInteger(value);
          if (x) {
            return { ...state, [name]: value };
          }

          return { ...state };

        case 'boxPrice':
        case 'seatPrice':
          const y = value === '' ? true : isInteger(value);
          if (y) {
            return { ...state, [name]: value };
          }

          return { ...state };

        case 'eventDescription':
          if (value === '' || (removeSpace(value) && value.length <= 1000)) {
            return { ...state, [name]: value };
          }
          return { ...state };

        case 'location':
          if (value.length <= 32) {
            return { ...state, [name]: value };
          }
          return { ...state };

        default:
          return { ...state };
      }
    },

    updateEditEventForm: (state, action) => {
      const { values } = action.payload;
      const editEventArray = Object.entries(values);
      const eventData = editEventArray.reduce((accumulator, currentVal) => {
        return { ...accumulator, [currentVal[0]]: currentVal[1] };
      }, {});
      return { ...state, ...eventData };
    },

    clearForm: () => {
      return {
        eventName: '',
        eventDescription: '',
        eventCapacity: '',
        participantPerBox: '',
        totalBoxes: '',
        boxPrice: '',
        seatPrice: '',
        location: '',
      };
    },
  },
});

export const { updateNewEventForm, updateEditEventForm, clearForm } =
  newEventSlice.actions;

export default newEventSlice.reducer;
